/**
 * Public-facing fare labels (supplier-neutral). API may still send TJ_FLEX.
 */
export function publicFareTypeLabel(raw) {
  const u = String(raw || '').trim().toUpperCase();
  if (u === 'TJ_FLEX') return 'ACF Flex';
  return raw || 'Standard';
}
